'use client';
import type { StaticImageData } from 'next/image';
import React from 'react';

import { Link } from '@/i18n/routing';

import type { IImage, IVariant } from '@/interfaces/products.interface';

import LoaderImage from '../LoaderImage';
import { useTranslations } from 'next-intl';

type IProps = {
  productName?: string;
  slug?: string;
  proudctId?: number;
  handleColorSelect?: (item_id: string, color: string) => void;
  handleSizeSelect?: (item_id: string, size: string) => void;
  selectedColor?: string | null;
  selectedSize?: string | null;
  variants?: IVariant[];
  colors?: string[];
  sizeItem?: string[];
  img?: StaticImageData;
  thumbnail?: IImage;
  price?: number;
  discountPrice?: number;
};

const Card: React.FC<IProps> = ({ productName, slug, variants, thumbnail }) => {
  const t = useTranslations('card');
  if (!variants || variants.length === 0) {
    return <div>{t('card_no_variant')}</div>;
  }
  const { price, sizes } = variants[0];

  return (
    <div className="group relative h-[400px] overflow-hidden xl:h-[600px]">
      <Link href={`/shop/${slug}`} className="cursor-pointer">
        <LoaderImage src={thumbnail?.s3url || ''} alt={productName || ''} className="!h-[400px] w-full xl:!h-[600px]" />
      </Link>
      <div className="absolute bottom-0 left-0 right-0 flex flex-col bg-white/30 p-4 text-lg opacity-0 backdrop-blur-md transition-opacity duration-300 group-hover:opacity-100 dark:bg-black/50">
        <div className="flex flex-col justify-between lg:flex-row">
          <Link href={`/shop/${slug}`} className="cursor-pointer">
            <h1>{productName}</h1>
          </Link>
          <h1 className="text-sm">€{price}</h1>
        </div>
        <div className="flex flex-col justify-between lg:flex-row lg:items-center">
          <div className="flex cursor-pointer">
            {variants?.map(variant => (
              <div key={variant?.colorCode} className="flex h-10 w-10 items-center justify-center">
                <div
                  className="h-5 w-5 cursor-pointer rounded-full border-2"
                  style={{ backgroundColor: variant?.colorCode }}
                />
              </div>
            ))}
          </div>
          <div className="flex gap-2">
            {sizes.map(({ sizeType, id }) => (
              <div key={id} className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full">
                {sizeType}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
